@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  <p-button icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
  styleClass="p-overlayPanel-trigger surface-0 p-button-outlined border-300 ml-2 text-600 text-sm" (click)="action.toggle($event)" />
  <p-popover #action styleClass="overflow-hidden text-sm w-10rem -ml-5">
    <ng-template #content>
      <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
        <li class="py-2 px-3 flex align-items-center text-700">
          <i class="fa fa-download text-xs mr-2"></i>
          <span class="font-bold">{{ 'SETTLEMENTS.DOWNLOAD' | translate }}</span>
        </li>
        <li class="cursor-pointer hover:surface-300 py-2 px-3" (click)="executeAction('pdf',$.row,action)">{{ 'SETTLEMENTS.SETTLEMENT_SUMMARY_PDF' | translate }}</li>
        <li class="cursor-pointer hover:surface-300 py-2 px-3" (click)="executeAction('csv',$.row,action) ">{{ 'SETTLEMENTS.SETTLEMENT_DETAILS_CSV' | translate }}</li>
        <li class="cursor-pointer hover:surface-300 py-2 px-3" (click)="executeAction('taxinvoice',$.row,action) ">{{ 'SETTLEMENTS.TAX_INVOICE' | translate }}</li>
      </ul>
    </ng-template>
  </p-popover>
}
